const { scrollmagic } = require("./modules/scrollmagic");
const { pageTop } = require("./modules/pageTop");
const { smooth } = require("./modules/smooth");
// const { shop } = require("./modules/shop");

scrollmagic();
pageTop();
smooth();
// shop();
